import { Component, input, OnInit, output } from '@angular/core';
import { HorizonData } from '../../../data/schemas/data/modeExecution';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from "../../modal/modal.component";
import { LigneBudgetaireService } from '../../../services/lignebudgetaire/lignebudgetaire.service';
import { AppService } from '../../../core/app.service';
import { LigneBudgetaireResponse } from '../../../data/http/responses/lignebudgetaire.res';
import { MatIcon } from "@angular/material/icon";
import { Input } from "../../forms/input/input";
import { SelectComponent } from "../../forms/select/select.component";
import { SelectOption } from '../../../data/schemas/selectoption.schema';
import { UiButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-stepthreeactivities',
  imports: [ReactiveFormsModule, ModalComponent, MatIcon, Input, SelectComponent, UiButtonComponent],
  templateUrl: './stepthreeactivities.component.html',
  styleUrl: './stepthreeactivities.component.css'
})
export class StepthreeactivitiesComponent implements OnInit {

  budgetsData = input<any>();
  budgetsChanges = output<any>();
  submitActivity = output<void>();

  public horizonData: SelectOption[] = [];
  public ligneBudgetaires: SelectOption[] = [];
  public budgetsForm: FormGroup = new FormGroup({});
  public showSubmitActiviteModal: boolean = false;

  private subscription: Subscription | undefined;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private ligneBudgetaireService: LigneBudgetaireService,
    private appService: AppService
  ) {
    this.horizonData = HorizonData.map(item => ({
      value: item.code,
      label: item.valeur
    }));

    this.budgetsForm = this.fb.group({
      DecaissementEstimatif:   ['', Validators.required],
      imputationBudgetaire:    ['', Validators.required],
      horizon:                 ['', Validators.required],
      EncaissementEstimatif:   ['', Validators.required],
      coutPrevuN1:             ['', Validators.required],
      previsionDecaissementN2: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.budgetsData()) {
      this.budgetsForm.patchValue(this.budgetsData());
    }
    this.loadLigneBudgetaire();
  }

  /** Revenir à l'étape précédente (activites) */
  goBack(): void {
    this.router.navigate([], {
      queryParams: { step: 'activites' },
      relativeTo: this.route
    });
  }

private numericFields = [
  'DecaissementEstimatif',
  'EncaissementEstimatif',
  'coutPrevuN1',
  'previsionDecaissementN2'
] as const;

onSubmitToLocalStorage(): void {
  if (this.budgetsForm.invalid) {
    this.budgetsForm.markAllAsTouched();
    return;
  }

  const rawValues = this.budgetsForm.value;

  // Normalisation : convertir les champs numériques en Number
  const normalizedValues = { ...rawValues };
  for (const field of this.numericFields) {
    const raw = String(rawValues[field] ?? '').replace(/\s/g, '');
    normalizedValues[field] = raw !== '' ? Number(raw) : null;
  }

  const existingData = localStorage.getItem('activity');
  let activityData = existingData ? JSON.parse(existingData) : {};

  activityData = {
    ...activityData,
    budgets: normalizedValues  // ← nombres propres ici
  };

  localStorage.setItem('activity', JSON.stringify(activityData));
  this.budgetsChanges.emit(normalizedValues);
}

  openSubmitActiviteModal(): void {
    this.showSubmitActiviteModal = true;
  }

  closeSubmitActiviteModal(): void {
    this.showSubmitActiviteModal = false;
  }

  loadLigneBudgetaire(): void {
    this.ligneBudgetaireService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.ligneBudgetaires = response.data.map((item: LigneBudgetaireResponse) => ({
          value: item.libelle,
          label: item.libelle
        }));
      },
      error: (error) => {
        console.error('Erreur lors du chargement des lignes budgétaires :', error);
      }
    });
  }

  onSubmitActiviteConfirm(): void {
    this.submitActivity.emit();
    this.closeSubmitActiviteModal();
  }
}